import View from "../../../Account/Js/views/ExpandView";
import components from "./components.js";
components.define("js-AccountExpand", View);